import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    PaginationControlDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    PaginationSize
} from "../../type";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

export const PAGINATION_SELECTED_VARIANTS: Record<PaginationSize, keyof NCoreUIKit.Typography> = {
    large: "titleMediumSize",
    medium: "titleSmallSize",
    small: "labelSmallSize"
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        borderStyle: "solid",
        alignItems: "center"
    },
    content: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    title: {
        textAlign: "center",
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 1
    }
});

export const useStyles = ({
    isFocusVisible,
    currentColors,
    borderRadius,
    shapeConfigs,
    touchTargets,
    currentSize,
    pointerType,
    isIconOnly,
    borders,
    colors,
    spaces,
    kind
}: PaginationControlDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: currentSize.minHeight,
        touchTargets,
        pointerType
    });

    const styles = {
        surface: {
            paddingHorizontal: kind === "page" ? spaces.spacingSm : currentSize.paddingHorizontal,
            backgroundColor: currentColors.containerColor,
            borderColor: currentColors.borderColor,
            minHeight: currentSize.minHeight,
            minWidth: currentSize.minHeight,
            borderWidth: borders.line,
            ...getCornerStyle({
                radius: borderRadius,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        container: {
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minWidth
        } as Mutable<ViewStyle>,
        content: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    if(isIconOnly) {
        delete styles.surface.paddingHorizontal;
    }

    return styles;
};
export default stylesheet;
